export const Teams = () => <div>Teams</div>;
export default Teams;
